import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "add",
  "use": "add-usage",
  "viewBox": "0 0 21 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 20\" id=\"add\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.167 10a8.333 8.333 0 1116.666 0 8.333 8.333 0 01-16.666 0zM10.5 0C4.977 0 .5 4.477.5 10s4.477 10 10 10 10-4.477 10-10-4.477-10-10-10zm0 5.833a.833.833 0 00-.833.834v2.5h-2.5a.833.833 0 100 1.666h2.5v2.5a.833.833 0 001.667 0v-2.5h2.5a.833.833 0 000-1.666h-2.5v-2.5a.833.833 0 00-.834-.834z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol